"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ROUTES = void 0;
/**
 * The URL surface, shared so the client cannot drift from the server.
 * Keep in sync with the NestJS controllers in `apps/tama-api/src`.
 */
exports.API_ROUTES = {
    health: '/health',
    createPet: '/pets',
    /** GET reads the current pet; DELETE releases it so a new one takes its place. */
    myPet: '/pets/me',
    /** GET reads the player's home map, PUT saves an edited one, DELETE resets it. */
    myWorld: '/world',
};
//# sourceMappingURL=routes.js.map